<template>
  <a-input
    ref="input"
    v-model="inputValue"
    :placeholder="placeholder || $t('search')"
    @change="handleSearch"
    :allowClear="true"
  />
</template>

<script>
import { debounce } from 'lodash'

export default {
  props: {
    searchVal: {
      type: String,
      required: true
    },
    clear: {
      type: Function,
      required: true
    },
    placeholder: {
      type: String,
      default() {
        return '';
      }
    }
  },
  watch: {
    searchVal(newValue) {
      this.inputValue = newValue;
    }
  },
  data() {
    return {
      inputValue: this.searchVal
    }
  },
  methods: {
    handleSearch: debounce(function () {
      this.$emit('onsearch', this.inputValue)
    }, 500),
    focus() {
      if (this.$refs.input && this.$refs.input.focus) this.$refs.input.focus()
    },
    clearValue() {
      this.inputValue = '';
      this.clear();
    }
  }
}
</script>
